/* eslint-disable react/jsx-no-target-blank */
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { ILayout, useLayout } from "../../core";
import { CaixaFooterBar } from "../../../../app/components/Caixa/CaixaFooterBar";

const Footer = () => {
  const { config } = useLayout();
  const { pathname } = useLocation();
  const isDashboard =
    pathname === "/dashboard" || pathname.startsWith("/dashboard/");

  useEffect(() => {
    updateDOM(config);
  }, [config]);

  if (!isDashboard) return null;

  return <CaixaFooterBar />;
};

const updateDOM = (config: ILayout) => {
  if (config.app?.footer?.fixed?.desktop) {
    document.body.classList.add("data-kt-app-footer-fixed", "true");
  }

  if (config.app?.footer?.fixed?.mobile) {
    document.body.classList.add("data-kt-app-footer-fixed-mobile", "true");
  }
};

export { Footer };
